import _ from 'lodash'

/*
 ** Handle count number from API. = null means it's unlimited
 */
export default function parseApiCount(n) {
  return _.isNil(n) ? Infinity : n
}
